// extracted by mini-css-extract-plugin
export default {"container":"CategorySelection_container__KVyIh","areaContainer":"CategorySelection_areaContainer__Ti4lf","areaSelector":"CategorySelection_areaSelector__flVit"};